(() => {
  const label = document.documentElement.lang.startsWith('fr') ? 'Avis Google sur Maison Kaze' : 'Google reviews for Maison Kaze';
  const titleFrames = () => {
    const frame = document.getElementById('merchantwidgetiframe');
    if (frame && !frame.title) frame.title = label;
  };
  const observer = new MutationObserver(titleFrames);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  const start = () => {
    const script = document.createElement('script');
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.async = true;
    script.addEventListener('load', () => {
      window.merchantwidget?.start({ merchant_id: 5871949100, position: 'RIGHT_BOTTOM' });
      titleFrames();
    }, { once: true });
    document.head.append(script);
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2000 });
    else setTimeout(start, 0);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
